import React from 'react'

function IndiaFirst() {
  return (
    <div>
      India first
    </div>
  )
}

export default IndiaFirst
